export const LEFT_MENU_ACTIVE_SETTING = [
  {
    key: 'study',
    isOpen: true,
  },
  {
    key: 'profile',
    isOpen: true,
  },
];
